import PreviewIcon from 'Assets/images/commons/previewIcon.svg';
import usePreviewFile from 'Hooks/files/usePreviewFile';
import useAuth from 'Hooks/useAuth';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './AttachmentsView.less';
import FileIconView from './FileIcon';

const AttachmentsView = ({ attachments }) => {
  const { handlePreview } = usePreviewFile();
  const { token } = useAuth();

  return (
    <div className={styles.container}>
      {attachments.map(attachment => {
        // eslint-disable-next-line no-nested-ternary
        return (
          <div key={attachment.id} className={styles.item}>
            <div className={styles.actions}>
              <div className={styles.preview} onClick={() => handlePreview(attachment, token)}>
                <img src={PreviewIcon} alt="Preview" />
              </div>
            </div>
            <FileIconView file={attachment} />
          </div>
        );
      })}
    </div>
  );
};

AttachmentsView.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default AttachmentsView;
